import {InjectionToken} from "@angular/core";
import {RangeDateControllerDirective} from "./range-date-controller.directive";

export const RANGE_DATE_CONTROLLER = new InjectionToken('RANGE_DATE_CONTROLLER', {
  factory() {
    return 'plug'
  }
})
